/**
 * @file Writes an exact ratio as a percentage rounded half away from zero:
 * one decimal place by default, such as `"62.4%"` or `"100.0%"`, for tiles
 * and Home; whole, such as `"75%"`, when `whole` is set, for table cells.
 * Consumers: the Overview tiles and attainment cells and the Home tiles and
 * goal bar. The ratio arrives unrounded from `goalProgress`, so the
 * percentage is rounded exactly once.
 */
import { analyticsFractionDecimal } from '#types';
import type { AnalyticsFraction } from '#types';

export const analyticsPercentText = (
  ratio: AnalyticsFraction,
  options?: { whole?: boolean },
): string =>
  `${analyticsFractionDecimal({ numerator: ratio.numerator * 100n, denominator: ratio.denominator }, options?.whole === true ? 0 : 1)}%`;
